
import React, { useState, useCallback } from 'react';
import { FaIcon } from './../../../index.js';
import NavLinkButton from './NavLinkButton';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
var NavSearch = function NavSearch(_ref) {
    var variant = _ref.variant,
        onSubmit = _ref.onSubmit,
        onChange = _ref.onChange;

    var _useState = useState(false),
        toggleSearch = _useState[0],
        setToggleSearch = _useState[1];

    var _useState2 = useState(''),
        searchText = _useState2[0],
        onChangeSearchText = _useState2[1];

    var toggleSearchBar = useCallback(function () {
        setToggleSearch(!toggleSearch);
    }, [toggleSearch]);

    var onChangeText = useCallback(function (e) {
        onChangeSearchText(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    }, [onChangeSearchText]);
    var onSubmitForm = useCallback(function (e) {
        e.preventDefault();
        if (onSubmit) onSubmit(searchText);
    }, [onSubmit, searchText]);
    return toggleSearch ? React.createElement(
        Form,
        { inline: true, onSubmit: onSubmitForm },
        React.createElement(Form.Control, { type: 'text', placeholder: 'Search', onChange: onChangeText, value: searchText }),
        React.createElement(
            NavLinkButton,
            { type: 'submit', className: 'rounded-0 ml-2', variant: variant },
            'Search'
        )
    ) : React.createElement(
        NavLinkButton,
        { onClick: toggleSearchBar },
        React.createElement(FaIcon, { icon: 'search', className: 'mr-2' }),
        ' Search'
    );
};

NavSearch.defaultProps = {
    variant: "primary"
};

NavSearch.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * Bootstrap color variant for search submit button
     */
    variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'outline-primary', 'outline-secondary', 'outline-success', 'outline-danger', 'outline-warning', 'outline-info', 'outline-dark', 'outline-light']),
    /**
     * trigger on submit by click on search submit button
     */
    onSubmit: PropTypes.func,
    /**
     * trigger on change search text
     */
    onChange: PropTypes.func
} : {};
export default NavSearch;